import { useMemo, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import type { ComboboxData } from '@mantine/core';
import { ADMIN, BRISTEC_ADMIN } from '../../../const/constants';

export function useAvailableAccountRole() {
	const auth = useAuth();

	const selectableRoles: ComboboxData = useMemo(() => {
		if ([ADMIN, BRISTEC_ADMIN].includes(auth.getRole())) {
			return [
				{ value: '1', label: 'User' },
				{ value: '2', label: 'Moderator' },
				{ value: '3', label: 'Admin' },
			];
		}

		return [{ value: '1', label: 'User' }];
	}, []);

	return selectableRoles;
}
